// BANDEJA PRODUCT PAGE | STARTER KIT | JS ASSET FILE
// File name in Shopify Assets: bandeja-starter-kit-product.js
// This script syncs Shopify stock and prices automatically from /products/starter-kit.js.

(function() {
  'use strict';

  var section = document.getElementById('bandeja-starter-kit-product-page');
  if (!section) return;

  var mainProductHandle = 'starter-kit';
  var whatsappNumber = '9613735578';
  var productTitle = 'The Starter Kit';
  var productImage = 'https://cdn.shopify.com/s/files/1/0692/1732/1008/files/Bandeja_Pressurizer_balls.jpg?v=1782474082';
  var fallbackPriceCents = 4500;
  var freeDeliveryThresholdCents = 4500;
  var deliveryFeeCents = 300;
  var scorePointerValueCents = 700;

  var bundleData = {
    1: {
      title: 'BUY 1',
      subtitle: 'Starter Kit',
      whatsappSubtitle: 'Pressurizer + Balls',
      variantId: 43328625868848,
      packCount: 1,
      freeScorePointers: 0,
      fallbackPriceCents: 4500,
      priceElementId: 'bsk-bundle-price-1',
      compareElementId: 'bsk-bundle-compare-1',
      saveElementId: 'bsk-bundle-save-1'
    },
    2: {
      title: 'BUY 2',
      subtitle: 'Double Kit',
      whatsappSubtitle: 'Two Starter Kits + Free Score Pointer',
      variantId: 43353041371184,
      packCount: 2,
      freeScorePointers: 1,
      fallbackPriceCents: 9000,
      priceElementId: 'bsk-bundle-price-2',
      compareElementId: 'bsk-bundle-compare-2',
      saveElementId: 'bsk-bundle-save-2'
    },
    3: {
      title: 'BUY 3',
      subtitle: 'Club Ready',
      whatsappSubtitle: 'Three Starter Kits + 2 Free Score Pointers',
      variantId: 43353041403952,
      packCount: 3,
      freeScorePointers: 2,
      fallbackPriceCents: 13500,
      priceElementId: 'bsk-bundle-price-3',
      compareElementId: 'bsk-bundle-compare-3',
      saveElementId: 'bsk-bundle-save-3'
    }
  };

  var upsellConfigs = [
    {
      variantId: 43323173896240,
      handle: 'padel-dampeners',
      priceElementId: 'bsk-upsell-price-1',
      title: 'Dampeners',
      image: 'https://cdn.shopify.com/s/files/1/0692/1732/1008/files/dampeners.jpg?v=1782474057',
      productUrl: '/products/padel-dampeners',
      fallbackPriceCents: 1500
    },
    {
      variantId: 43323174387760,
      handle: 'score-pointer',
      priceElementId: 'bsk-upsell-price-2',
      title: 'Scoring Pointer',
      image: 'https://cdn.shopify.com/s/files/1/0692/1732/1008/files/score_pointer.jpg?v=1782474256',
      productUrl: '/products/score-pointer',
      fallbackPriceCents: 700
    }
  ];

  var selectedPlan = 1;
  var quantity = 1;
  var currentVariantId = bundleData[1].variantId;
  var currentVariantTitle = bundleData[1].title;
  var currentPriceCents = fallbackPriceCents;
  var currentCompareCents = 0;
  var isInStock = true;
  var isSyncing = false;
  var upsellData = {};

  var quantitySpan = document.getElementById('bsk-quantity');
  var addToCartBtn = document.getElementById('bsk-add-to-cart');
  var successMsg = document.getElementById('bsk-cart-success');
  var mainPriceEl = document.getElementById('bsk-main-price');
  var comparePriceEl = document.getElementById('bsk-compare-price');
  var saveBadgeEl = document.getElementById('bsk-save-badge');
  var whatsappBtn = document.getElementById('bsk-whatsapp-btn');
  var stockLine = document.getElementById('bsk-stock-line');
  var stockText = document.getElementById('bsk-stock-text');

  function formatMoney(cents) {
    var amount = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount);
    }

    return '$' + (amount / 100).toFixed(2);
  }

  function showMessage(message, isError) {
    if (!successMsg) return;

    successMsg.textContent = message;
    successMsg.style.color = isError ? '#ff8a8a' : '#d3ff21';
    successMsg.classList.add('show');

    window.setTimeout(function() {
      successMsg.classList.remove('show');
    }, 2400);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Failed to load product ' + handle);
      return response.json();
    });
  }

  function findVariant(product, preferredVariantId) {
    if (!product || !product.variants || !product.variants.length) return null;

    return product.variants.find(function(variant) {
      return String(variant.id) === String(preferredVariantId);
    }) || null;
  }

  function getPlanBaseCompareCents(planKey) {
    var plan = bundleData[Number(planKey)];
    if (!plan) return 0;

    if (plan.compareCents && plan.compareCents > plan.priceCents) {
      return plan.compareCents;
    }

    var buyOne = bundleData[1];
    var buyOnePrice = Number(buyOne && buyOne.priceCents ? buyOne.priceCents : fallbackPriceCents);
    var freeGiftValue = Number(plan.freeScorePointers || 0) * scorePointerValueCents;

    if (plan.packCount > 1) {
      return (buyOnePrice * plan.packCount) + freeGiftValue;
    }

    return Number(plan.compareCents || 0);
  }

  function getPlanSaveCents(planKey) {
    var plan = bundleData[Number(planKey)];
    if (!plan || !plan.priceCents) return 0;

    var compareCents = getPlanBaseCompareCents(planKey);
    return Math.max(0, compareCents - plan.priceCents);
  }

  function updateBundleCardDisplay(planKey) {
    var plan = bundleData[Number(planKey)];
    if (!plan) return;

    var priceEl = document.getElementById(plan.priceElementId);
    var compareEl = document.getElementById(plan.compareElementId);
    var saveEl = document.getElementById(plan.saveElementId);
    var card = section.querySelector('.bsk-bundle-card[data-plan="' + planKey + '"]');

    var priceCents = Number(plan.priceCents || plan.fallbackPriceCents || 0);
    var compareCents = getPlanBaseCompareCents(planKey);
    var saveCents = getPlanSaveCents(planKey);

    if (priceEl) priceEl.textContent = formatMoney(priceCents);

    if (compareEl) {
      if (compareCents > priceCents) {
        compareEl.textContent = formatMoney(compareCents);
        compareEl.style.display = 'block';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    if (saveEl) {
      if (saveCents > 0) {
        saveEl.textContent = 'SAVE ' + formatMoney(saveCents).replace('.00', '');
      } else if (Number(planKey) === 1) {
        saveEl.textContent = 'STANDARD PACK';
      } else {
        saveEl.textContent = 'PRICE SYNCED';
      }
    }

    if (card) {
      card.classList.toggle('is-sold-out', plan.inStock === false);
    }
  }

  function updateAllBundleCards() {
    Object.keys(bundleData).forEach(updateBundleCardDisplay);
  }

  function updateComparePrice() {
    var hasCompare = currentCompareCents > currentPriceCents;
    var saveCents = Math.max(0, currentCompareCents - currentPriceCents);

    if (comparePriceEl) {
      if (hasCompare) {
        comparePriceEl.textContent = formatMoney(currentCompareCents);
        comparePriceEl.style.display = 'inline-flex';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    if (saveBadgeEl) {
      if (saveCents > 0) {
        saveBadgeEl.textContent = 'SAVE ' + formatMoney(saveCents).replace('.00', '');
        saveBadgeEl.style.display = 'inline-flex';
      } else {
        saveBadgeEl.textContent = selectedPlan === 1 ? 'STANDARD PACK' : 'PRICE SYNCED';
        saveBadgeEl.style.display = 'inline-flex';
      }
    }
  }

  function updateStockDisplay() {
    if (!stockLine || !stockText) return;

    stockLine.classList.toggle('is-sold-out', !isInStock);
    stockText.textContent = isInStock ? 'In stock and ready to ship' : 'Sold out';
  }

  function updateAddToCartButton() {
    if (!addToCartBtn) return;

    if (!isInStock) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Sold Out';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add To Cart';
    }
  }

  function getDeliveryCents(subtotalCents) {
    return subtotalCents >= freeDeliveryThresholdCents ? 0 : deliveryFeeCents;
  }

  function getDisplayProductTitle() {
    var item = bundleData[selectedPlan];

    if (item) {
      return productTitle + ' - ' + item.title + ' (' + item.subtitle + ')';
    }

    return productTitle;
  }

  function updateWhatsAppLink() {
    if (!whatsappBtn) return;

    var item = bundleData[selectedPlan];
    var subtotalCents = currentPriceCents;
    var deliveryCents = getDeliveryCents(subtotalCents);
    var totalCents = subtotalCents + deliveryCents;
    var saveCents = getPlanSaveCents(selectedPlan);
    var deliveryText = deliveryCents === 0 ? 'free delivery' : 'delivery fee ' + formatMoney(deliveryCents);
    var saveText = saveCents > 0 ? ' and save ' + formatMoney(saveCents).replace('.00', '') : '';
    var giftText = item && item.freeScorePointers === 1
      ? ' with 1 free Score Pointer'
      : item && item.freeScorePointers > 1
        ? ' with ' + item.freeScorePointers + ' free Score Pointers'
        : '';

    var message = 'Hello i am intrested in ' + getDisplayProductTitle() +
      giftText +
      ' for price of ' + formatMoney(currentPriceCents) +
      saveText +
      ' with ' + deliveryText +
      '. Total=' + formatMoney(totalCents);

    whatsappBtn.href = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);
  }

  function updateQuantityDisplay() {
    if (quantitySpan) quantitySpan.textContent = String(quantity);
    updateWhatsAppLink();
  }

  function selectPlan(planKey) {
    var nextPlan = Number(planKey);
    var item = bundleData[nextPlan];

    if (!item) return;

    if (item.inStock === false) {
      showMessage('This option is sold out.', true);
      return;
    }

    selectedPlan = nextPlan;
    currentVariantId = item.variantId;
    currentVariantTitle = item.title;
    currentPriceCents = Number(item.priceCents || item.fallbackPriceCents || fallbackPriceCents);
    currentCompareCents = getPlanBaseCompareCents(selectedPlan);
    isInStock = item.inStock !== false;
    quantity = 1;

    section.querySelectorAll('.bsk-bundle-card').forEach(function(card) {
      var isSelected = Number(card.getAttribute('data-plan')) === selectedPlan;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (addToCartBtn) addToCartBtn.setAttribute('data-variant-id', String(currentVariantId));
    if (mainPriceEl) mainPriceEl.textContent = formatMoney(currentPriceCents);

    updateComparePrice();
    updateStockDisplay();
    updateAddToCartButton();
    updateQuantityDisplay();
  }

  function syncMainProductData() {
    if (isSyncing) return Promise.resolve();
    isSyncing = true;

    return fetchProduct(mainProductHandle).then(function(product) {
      Object.keys(bundleData).forEach(function(planKey) {
        var plan = bundleData[Number(planKey)];
        var variant = findVariant(product, plan.variantId);

        if (!variant) return;

        plan.variantId = variant.id;
        plan.variantTitle = variant.title || plan.title;
        plan.priceCents = Number(variant.price || plan.fallbackPriceCents || 0);
        plan.compareCents = Number(variant.compare_at_price || 0);
        plan.inStock = Boolean(variant.available);
      });

      updateAllBundleCards();
      selectPlan(selectedPlan);
    }).catch(function(error) {
      console.warn('Bandeja starter kit sync failed:', error);

      Object.keys(bundleData).forEach(function(planKey) {
        var plan = bundleData[Number(planKey)];
        plan.priceCents = Number(plan.priceCents || plan.fallbackPriceCents || fallbackPriceCents || 0);
        plan.compareCents = Number(plan.compareCents || 0);
        plan.inStock = plan.inStock !== false;
      });

      updateAllBundleCards();
      selectPlan(selectedPlan);
    }).finally(function() {
      isSyncing = false;
    });
  }

  function syncUpsellProduct(config) {
    return fetchProduct(config.handle).then(function(product) {
      var variant = findVariant(product, config.variantId);
      if (!variant) return;

      var priceCents = Number(variant.price || config.fallbackPriceCents);
      var inStock = Boolean(variant.available);

      if (config.handle === 'score-pointer') {
        scorePointerValueCents = priceCents || scorePointerValueCents;
      }

      upsellData[String(config.variantId)] = {
        variantId: variant.id,
        title: config.title,
        priceCents: priceCents,
        inStock: inStock,
        image: config.image,
        handle: config.handle,
        productUrl: config.productUrl
      };

      var priceEl = document.getElementById(config.priceElementId);
      if (priceEl) priceEl.textContent = formatMoney(priceCents);

      var card = section.querySelector('.bsk-upsell-card[data-upsell-variant-id="' + config.variantId + '"]');
      var btn = card ? card.querySelector('.bsk-upsell-add-btn') : null;

      if (btn) {
        btn.disabled = !inStock;
        btn.textContent = inStock ? 'Add To Cart' : 'Sold Out';
      }

      updateAllBundleCards();
      selectPlan(selectedPlan);
    }).catch(function(error) {
      console.warn('Bandeja upsell sync failed:', config.handle, error);

      upsellData[String(config.variantId)] = {
        variantId: config.variantId,
        title: config.title,
        priceCents: config.fallbackPriceCents,
        inStock: true,
        image: config.image,
        handle: config.handle,
        productUrl: config.productUrl
      };

      var priceEl = document.getElementById(config.priceElementId);
      if (priceEl) priceEl.textContent = formatMoney(config.fallbackPriceCents);
    });
  }

  function syncAllUpsells() {
    return Promise.all(upsellConfigs.map(syncUpsellProduct));
  }

  function addToCartViaShopify(variantId, title, image, handle, qty, priceCents, variantTitle) {
    var quantityToAdd = qty || 1;

    if (typeof window.addToCart === 'function') {
      return window.addToCart({
        title: title,
        variant: variantTitle || '',
        price: formatMoney(priceCents),
        variantId: String(variantId),
        quantity: quantityToAdd,
        image: image,
        handle: handle
      });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantityToAdd
      })
    }).then(function(response) {
      if (!response.ok) {
        return response.json().catch(function() {
          return null;
        }).then(function(errorData) {
          throw new Error(errorData && errorData.description ? errorData.description : 'Failed to add to cart');
        });
      }

      if (typeof window.openBandejaCartDrawer === 'function') {
        window.openBandejaCartDrawer();
      }

      document.dispatchEvent(new CustomEvent('bandeja:cart:open', { detail: { bandejaAllowed: true } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }

  function handleMainAddToCart() {
    if (!isInStock) {
      showMessage('This option is out of stock.', true);
      return;
    }

    if (!addToCartBtn) return;

    var originalText = addToCartBtn.textContent;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding';

    addToCartViaShopify(
      currentVariantId,
      getDisplayProductTitle(),
      productImage,
      mainProductHandle,
      1,
      currentPriceCents,
      currentVariantTitle
    ).then(function() {
      showMessage(bundleData[selectedPlan].title + ' added to cart.');
    }).catch(function(error) {
      showMessage(error && error.message ? error.message : 'Error adding to cart.', true);
    }).finally(function() {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = originalText;
      updateAddToCartButton();
    });
  }

  function handleUpsellAddToCart(event, btn, variantId) {
    event.preventDefault();
    event.stopPropagation();

    var data = upsellData[String(variantId)];

    if (!data) {
      showMessage('Product data is still loading.', true);
      return;
    }

    if (!data.inStock) {
      showMessage(data.title + ' is sold out.', true);
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';

    addToCartViaShopify(
      data.variantId,
      data.title,
      data.image,
      data.handle,
      1,
      data.priceCents,
      ''
    ).then(function() {
      showMessage(data.title + ' added to cart.');
    }).catch(function(error) {
      showMessage(error && error.message ? error.message : 'Error adding to cart.', true);
    }).finally(function() {
      btn.disabled = false;
      btn.textContent = originalText;
    });
  }

  section.querySelectorAll('.bsk-bundle-card').forEach(function(card) {
    card.addEventListener('click', function() {
      selectPlan(card.getAttribute('data-plan'));
    });
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleMainAddToCart);
  }

  section.querySelectorAll('.bsk-upsell-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function(event) {
      var variantId = btn.getAttribute('data-variant-id');
      handleUpsellAddToCart(event, btn, variantId);
    });
  });

  section.querySelectorAll('.bsk-upsell-card').forEach(function(card) {
    card.addEventListener('click', function(event) {
      if (event.target.closest('.bsk-upsell-add-btn')) return;

      var url = card.getAttribute('data-upsell-url');
      if (url) window.location.href = url;
    });
  });

  var reviewLink = section.querySelector('.bsk-review-count');
  if (reviewLink) {
    reviewLink.addEventListener('click', function() {
      var reviewsSection = document.getElementById('shopify-product-reviews') || document.querySelector('[data-reviews]');
      if (reviewsSection) reviewsSection.scrollIntoView({ behavior: 'smooth' });
    });
  }

  section.querySelectorAll('.bsk-collapsible').forEach(function(collapsible) {
    var header = collapsible.querySelector('.bsk-collapsible-header');

    if (!header) return;

    function toggleCollapsible() {
      var isOpen = collapsible.classList.contains('is-open');
      collapsible.classList.toggle('is-open', !isOpen);
      header.setAttribute('aria-expanded', String(!isOpen));
    }

    header.addEventListener('click', toggleCollapsible);

    header.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleCollapsible();
      }
    });
  });

  updateAllBundleCards();
  selectPlan(1);
  updateAddToCartButton();
  updateStockDisplay();
  syncMainProductData();
  syncAllUpsells();

  window.setInterval(syncMainProductData, 300000);
  window.setInterval(syncAllUpsells, 300000);
})();
